import { FormattedMessage } from 'react-intl';
import React from 'react';

const LearnMoreButtonStrings = {
  learMore: (
    <FormattedMessage
      id="calendar.sync_flow.dialog.button_learn_more"
      defaultMessage="Learn more"
    />
  )
};

export default LearnMoreButtonStrings;
